<template>
  <ModalCard
    width="600px"
    :close-in-modal="false"
    :data-e2e="FinancialAdvisorEstateCypressAttribute.modal.views.ADVISOR_PRO_UPSELL_FREE_WILLS_MODAL"
  >
    <template #body>
      <section class="has-text-centered px-6 pb-6">
        <h2 class="is-size-2 has-text-weight-semibold">
          {{ $t('financialadvisor.pro-upsell-free-online-wills-modal-title') }}
        </h2>
        <p class="is-size-4 whitespace-pre-line">
          {{ $t('financialadvisor.pro-upsell-free-online-wills-modal-body') }}
        </p>
      </section>
    </template>
  </ModalCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ModalCard from '@/modules/core/ui/components/ModalCard.vue';
import { FinancialAdvisorEstateCypressAttribute } from '@/modules/financialadvisor/constants/FinancialAdvisorEstateCypressAttribute';

export default defineComponent({
  name: 'FinancialAdvisorFreeOnlineWillsModal',
  components: {
    ModalCard
  },
  static: {
    FinancialAdvisorEstateCypressAttribute
  }
});
</script>
